import {
  RazorTable,
  RazorTableRow,
  RazorTextTrim,
} from "../../../components/razor-reuse";
import { useEffect, useState } from "react";
import "../../../styles/dashboard/roles/RolesIndex.css";
import TitleBtnFragment from "../../../components/fragment/title-btn/TitleBtnFragment";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import PaginationFragment from "../../../components/fragment/pagination/PaginationFragment";
import DotActionDropFragment from "../../../components/fragment/actionIconFragment/DotActionDropFragment";
import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import DeleteRoleModal from "./DeleteRoleModal";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import { getAllRoles } from "../../../redux/role";
import {
  addZeroToNumber,
  capitalizeFirstLetter,
  formatTime,
  SPECIAL_ROLES,
} from "../../../utils/Helper";
import { systemRoles } from "../../../utils/roles";

const RolesIndex = () => {
  const dispatch = useDispatch();
  const { loading, all_roles } = useSelector((state: RootState) => state.roles);
  const [singleChild, setSingleChild] = useState({});
  const { user } = useSelector((state: RootState) => state.auth);
  const [currentPageVal, setCurrentPage] = useState(1);
  type modalProps = {
    add: boolean;
    edit: boolean;
    delete: boolean;
  };

  const [showModal, setShowModal] = useState<modalProps>({
    add: false,
    edit: false,
    delete: false,
  });

  const navigate = useNavigate();
  const headerList = [
    "Role Name",
    "Description",
    "User Count",
    "Date Created",
    "Actions",
  ];

  const actionList = [
    {
      icon: ALL_ICONS?.view,
      label: "View",
      onClick: (param?: any) => {
        localStorage?.setItem("roleKey", param?.id);
        navigate(ALL_ROUTES?.DASHBOARD_ROLES_VIEW);
      },
      textColor: "",
    },
    {
      icon: ALL_ICONS?.edit,
      label: "Edit",
      onClick: (param?: any) => {
        localStorage?.setItem("roleKey", param?.id);
        navigate(ALL_ROUTES?.DASHBOARD_ROLES_EDIT);
      },
      textColor: "",
    },
    {
      icon: ALL_ICONS?.delete,
      label: "Delete",
      onClick: (param?: any) => {
        setSingleChild(param);
        setShowModal((prev) => {
          return { ...prev, delete: true };
        });
      },
      textColor: "rgba(225, 25, 0, 1)",
    },
  ];

  const updateActionArray = (hideObj?: any, hideObjTwo?: any) => {
    const newList = actionList?.map((chi) => {
      return chi?.label === hideObj?.label
        ? { ...chi, hide: hideObj?.hide ? true : false }
        : { ...chi };
    });
    const secondList = newList?.map((chi) => {
      return chi?.label === hideObjTwo?.label
        ? { ...chi, hide: hideObjTwo?.hide ? true : false }
        : { ...chi };
    });
    return secondList;
  };

  const [refreshtable, setRefreshTable] = useState(false);

  useEffect(() => {
    const obj = {
      page: currentPageVal,
    };
    if (
      user?.permissions?.includes(systemRoles[23]) &&
      user?.permissions?.length > 0
    ) {
      dispatch(getAllRoles(obj) as any);
    }
  }, [refreshtable, currentPageVal, user?.permissions]);

  useEffect(() => {
    if (
      !user?.permissions?.includes(systemRoles[23]) &&
      user?.permissions?.length > 0
    ) {
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
    }
  }, [navigate, user]);

  const handleFinish = () => {
    setShowModal({ add: false, edit: false, delete: false });
    setRefreshTable(!refreshtable);
  };

  return (
    <>
      <DashboardLayoutMain
        loading={Object?.keys(all_roles)?.length < 1 && loading}
        title="Roles"
      >
        {/* role index wrapper start */}
        <div className="role-general-index-smart-send-wrapper-box">
          {/* title fragment start */}
          <TitleBtnFragment
            onBtnClick={() => {
              navigate(ALL_ROUTES?.DASHBOARD_ROLES_ADD);
              // console.log(all_roles);
            }}
            title="Manage Roles"
            btnLabel="Add New Role"
            hideBtn={loading || !user?.permissions?.includes(systemRoles[21])}
          />
          {/* title fragment end */}
          <div
            onClick={() => {
              console.log(all_roles);
            }}
            className="table-section-box"
          >
            {" "}
            <RazorTable headerList={headerList}>
              {all_roles?.data?.map((chi: any, idx: any) => {
                return (
                  <RazorTableRow
                    loading={loading}
                    one={capitalizeFirstLetter(chi?.name?.replaceAll("_", " "))}
                    two={RazorTextTrim(
                      capitalizeFirstLetter(chi?.description),
                      45
                    )}
                    three={addZeroToNumber(chi?.count)}
                    four={formatTime(chi?.created_at)}
                    five={
                      <>
                        <DotActionDropFragment
                          list={updateActionArray(
                            {
                              hide:
                                SPECIAL_ROLES?.includes(chi?.name) ||
                                !user?.permissions?.includes(systemRoles[24]),
                              label: "Delete",
                            },
                            {
                              hide:
                                SPECIAL_ROLES?.includes(chi?.name) ||
                                !user?.permissions?.includes(systemRoles[22]),
                              label: "Edit",
                            }
                          )}
                          detail={chi}
                        />
                      </>
                    }
                    key={idx}
                    onRowClick={() => {
                      // console.log(chi);
                      localStorage?.setItem("roleKey", chi?.id);
                      navigate(ALL_ROUTES?.DASHBOARD_ROLES_VIEW);
                    }}
                  />
                );
              })}
            </RazorTable>
          </div>
          {/* table end */}
          {/* pagination start */}
          <PaginationFragment
            currentPage={all_roles?.meta?.current_page || 1}
            perPage={all_roles?.meta?.per_page}
            totalPage={all_roles?.meta?.total}
            onPageChange={(num) => {
              setCurrentPage(num);
              // console.log(num);
            }}
            hidePagination={loading}
          />
          {/* pagination  end */}
        </div>
        {/* role index wrapper end */}
      </DashboardLayoutMain>
      {/* modal start */}
      <DeleteRoleModal
        visible={showModal?.delete}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, delete: false };
          });
        }}
        details={singleChild}
        onFinish={handleFinish}
      />
      {/* modal end */}
    </>
  );
};

export default RolesIndex;
